import { RouteObject } from 'react-router-dom';
import LoginSelectPage from '@/pages/login/page';
import ManagementLogin from '@/pages/login/ManagementLogin';
import SubcontractorLogin from '@/pages/login/SubcontractorLogin';
import ClientLogin from '@/pages/login/ClientLogin';
import ManagementDashboard from '@/pages/management/dashboard/page';
import ManagementProjectList from '@/pages/management/projects/page';
import NewProject from '@/pages/management/projects/NewProject';
import ProjectDetail from '@/pages/management/projects/ProjectDetail';
import EditProject from '@/pages/management/projects/EditProject';
import StageProgress from '@/pages/management/projects/StageProgress';
import ManagementNotifications from '@/pages/management/notifications/page';
import ManagementDailyLog from '@/pages/management/daily-log/page';
import ManagementInstructions from '@/pages/management/instructions/page';
import ManagementChangeOrders from '@/pages/management/change-orders/page';
import ManagementTemplates from '@/pages/management/templates/page';
import SubcontractorDashboard from '@/pages/subcontractor/dashboard/page';
import SubcontractorInstructions from '@/pages/subcontractor/instructions/page';
import SubcontractorDailyLog from '@/pages/subcontractor/daily-log/page';
import SubcontractorNotifications from '@/pages/subcontractor/notifications/page';
import SubcontractorProjectDetail from '@/pages/subcontractor/project/page';
import SubcontractorStageDetail from '@/pages/subcontractor/stage/page';
import ClientPortal from '@/pages/client/portal/page';
import ClientInstructions from '@/pages/client/instructions/page';
import ClientDailyLog from '@/pages/client/daily-log/page';
import ClientPayments from '@/pages/client/payments/page';
import ClientQuestions from '@/pages/client/questions/page';
import ClientChangeOrders from '@/pages/client/change-orders/page';
import ClientNotifications from '@/pages/client/notifications/page';
import AuthGuard from '@/components/feature/AuthGuard';
import NotFound from '@/pages/NotFound';
import DebugAuth from '@/pages/debug/DebugAuth';

const routes: RouteObject[] = [
  // Login flows
  { path: '/', element: <LoginSelectPage /> },
  { path: '/login', element: <LoginSelectPage /> },
  { path: '/login/management', element: <ManagementLogin /> },
  { path: '/login/subcontractor', element: <SubcontractorLogin /> },
  { path: '/login/client', element: <ClientLogin /> },

  // Management routes (protected)
  {
    path: '/management/dashboard',
    element: <AuthGuard requiredRole="management"><ManagementDashboard /></AuthGuard>,
  },
  {
    path: '/management/projects',
    element: <AuthGuard requiredRole="management"><ManagementProjectList /></AuthGuard>,
  },
  {
    path: '/management/projects/new',
    element: <AuthGuard requiredRole="management"><NewProject /></AuthGuard>,
  },
  {
    path: '/management/projects/:id',
    element: <AuthGuard requiredRole="management"><ProjectDetail /></AuthGuard>,
  },
  {
    path: '/management/projects/:id/edit',
    element: <AuthGuard requiredRole="management"><EditProject /></AuthGuard>,
  },
  {
    path: '/management/projects/:id/stage/:stageId',
    element: <AuthGuard requiredRole="management"><StageProgress /></AuthGuard>,
  },
  {
    path: '/management/daily-log',
    element: <AuthGuard requiredRole="management"><ManagementDailyLog /></AuthGuard>,
  },
  {
    path: '/management/instructions',
    element: <AuthGuard requiredRole="management"><ManagementInstructions /></AuthGuard>,
  },
  {
    path: '/management/change-orders',
    element: <AuthGuard requiredRole="management"><ManagementChangeOrders /></AuthGuard>,
  },
  {
    path: '/management/schedule-templates',
    element: <AuthGuard requiredRole="management"><ManagementTemplates /></AuthGuard>,
  },
  {
    path: '/management/templates',
    element: <AuthGuard requiredRole="management"><ManagementTemplates /></AuthGuard>,
  },
  {
    path: '/management/notifications',
    element: <AuthGuard requiredRole="management"><ManagementNotifications /></AuthGuard>,
  },

  // Subcontractor routes (protected)
  {
    path: '/subcontractor/dashboard',
    element: <AuthGuard requiredRole="subcontractor"><SubcontractorDashboard /></AuthGuard>,
  },
  {
    path: '/subcontractor/instructions',
    element: <AuthGuard requiredRole="subcontractor"><SubcontractorInstructions /></AuthGuard>,
  },
  {
    path: '/subcontractor/daily-log',
    element: <AuthGuard requiredRole="subcontractor"><SubcontractorDailyLog /></AuthGuard>,
  },
  {
    path: '/subcontractor/project/:id',
    element: <AuthGuard requiredRole="subcontractor"><SubcontractorProjectDetail /></AuthGuard>,
  },
  {
    path: '/subcontractor/project/:id/stage/:stageId',
    element: <AuthGuard requiredRole="subcontractor"><SubcontractorStageDetail /></AuthGuard>,
  },
  {
    path: '/subcontractor/notifications',
    element: <AuthGuard requiredRole="subcontractor"><SubcontractorNotifications /></AuthGuard>,
  },

  // Client routes (protected)
  {
    path: '/client/portal',
    element: <AuthGuard requiredRole="client"><ClientPortal /></AuthGuard>,
  },
  {
    path: '/client/updates',
    element: <AuthGuard requiredRole="client"><ClientPortal /></AuthGuard>,
  },
  {
    path: '/client/instructions',
    element: <AuthGuard requiredRole="client"><ClientInstructions /></AuthGuard>,
  },
  {
    path: '/client/change-orders',
    element: <AuthGuard requiredRole="client"><ClientChangeOrders /></AuthGuard>,
  },
  {
    path: '/client/daily-log',
    element: <AuthGuard requiredRole="client"><ClientDailyLog /></AuthGuard>,
  },
  {
    path: '/client/payments',
    element: <AuthGuard requiredRole="client"><ClientPayments /></AuthGuard>,
  },
  {
    path: '/client/questions',
    element: <AuthGuard requiredRole="client"><ClientQuestions /></AuthGuard>,
  },
  {
    path: '/client/notifications',
    element: <AuthGuard requiredRole="client"><ClientNotifications /></AuthGuard>,
  },

  { path: '/debug-auth', element: <DebugAuth /> },
  { path: '*', element: <NotFound /> },
];

export const appRoutes = routes;
export default routes;